import React, { useState, useEffect } from 'react';
import {Text, View} from "react-native";
import { connect } from 'react-redux';

import {Card, UserAvatar} from "../";
import get from "../../api/methods/get";
import {GET_USER_AVATAR} from "../../api/userEndpoints";

const UserCard = (props) => {

    const { userId } = props;

    const [avatarImage, setAvatarImage] = useState(null);

    useEffect(() => {
        const fetchAvatar = async (userId) => {
            try {
                let getResult = await get(GET_USER_AVATAR(userId));
                let getJson = await getResult.json();
                setAvatarImage(getJson.data);
            } catch (e) {

            }
        }

        fetchAvatar(userId);
    }, [userId])


    return (
        <Card containerStyle={{ flexDirection: 'row', margin: 20,  }}>
            <UserAvatar
                userName={props.name}
                userAvatarColor={props.avatarColor}
                userAvatarData={avatarImage}
                avatarPropsStyle={{
                    width: 80,
                    height: 80,
                }}
            />
            <View style={{ alignItems: 'flex-start', flex: 1, marginLeft: 8 }}>
                <Text style={{ fontSize: 18, marginBottom: 6, marginTop: 12, color: 'white' }}>
                    {props.name}
                </Text>
                <Text style={{ fontSize: 16, color: 'white' }}>
                    {`Pontos: ${props.points}`}
                </Text>
            </View>
        </Card>
    )
}

const mapStateToProps = (state) => {
    return {
        userId: state.user.userId,
        name: state.user.userName,
        avatarColor: state.user.avatarColor,
        avatarUri: state.user.userAvatar,
        points: state.user.points,
    }
}

export default connect(mapStateToProps)(UserCard);
